const RESTRICT = {
    HOTEL_QUEUE: 'HOTEL_QUEUE', // Access to View Hotel API Queue
};

export default RESTRICT;
  